import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';

function UserSMSDisclosure({ showDisclosure, setShowDisclosure }) {
  return (
    <Box>
      <button
        type="button"
        onClick={() => setShowDisclosure(true)}
        style={{
          background: 'none',
          border: 'none',
          color: '#1976d2',
          textDecoration: 'underline',
          cursor: 'pointer',
          padding: 0,
          font: 'inherit',
        }}>
        <FormattedMessage
          id="SMS_OPT_IN_DISCLOSURE_BUTTON"
          defaultMessage="Disclosure"
        />
      </button>
      <Dialog open={showDisclosure} onClose={() => setShowDisclosure(false)}>
        <DialogTitle>
          <FormattedMessage
            id="SMS_OPT_IN_DISCLOSURE"
            defaultMessage="SMS Opt-In Disclosure"
          />
        </DialogTitle>
        <DialogContent>
          <Typography>
            <FormattedMessage
              id="USER_SMS_DISCLOSURE_DESCRIPTION"
              defaultMessage="Would you like to receive SMS updates about your appointment?"
            />
          </Typography>
          <ul style={{ margin: 0, padding: '10px 0 0 17px' }}>
            <li>
              <FormattedMessage
                id="USER_SMS_DISCLOSURE_DESCRIPTION_1"
                defaultMessage="Your phone number will remain private and not be shared with the Service Company or sold or disclosed to third parties for marketing or promotional purposes."
              />
            </li>
            <li>
              <FormattedMessage
                id="USER_SMS_DISCLOSURE_DESCRIPTION_2"
                defaultMessage="Messages may be stored and monitored for quality assurance and training purposes."
              />
            </li>
            <li>
              <FormattedMessage
                id="USER_SMS_DISCLOSURE_DESCRIPTION_3"
                defaultMessage="Msg & Data rates may apply. Msg frequency varies based on service activity. Reply HELP for help. You can reply STOP at any time to unsubscribe."
              />
            </li>
            <Stack
              sx={{ justifySelf: 'center', mt: 2 }}
              direction="row"
              spacing={2}>
              <a target="_blank" href="/legal/terms">
                <FormattedMessage
                  id="USER_SMS_DISCLOSURE_TERMS"
                  defaultMessage="Terms"
                />
              </a>
              <a target="_blank" href="/legal/privacy">
                <FormattedMessage
                  id="USER_SMS_DISCLOSURE_PRIVACY"
                  defaultMessage="Privacy"
                />
              </a>
            </Stack>
          </ul>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button variant="contained" onClick={() => setShowDisclosure(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default UserSMSDisclosure;
